import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableBonusReportView.
 * @extends JetView
 */
export default class tableBonusReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 60, sort: 'int' }, // ID column
                {
                    id: 'ClientId',
                    header: _('ID Cliente'), // Client ID column with localization
                    width: 60,
                    sort: 'int',
                },
                {
                    id: 'PartnerBonusId',
                    header: _('Partner Bonus Id'), // Partner Bonus ID column with localization
                    width: 65,
                    sort: 'int',
                },
                {
                    id: 'Name',
                    header: _('Nombre de Bono'), // Bonus Name column with localization
                    width: 500,
                    sort: 'int',
                },
                {
                    id: 'AcceptanceDateLocal',
                    header: _('Fecha Aceptación'), // Acceptance Date column with localization
                    width: 150,
                    sort: 'int',
                },
                { id: 'BonusType', header: _('Tipo'), width: 100, sort: 'int' }, // Bonus Type column
                {
                    id: 'AcceptanceType',
                    header: _('Estado'), // Acceptance Type column with localization
                    width: 100,
                    sort: 'int',
                },
                { id: 'Amount', header: _('Valor'), width: 100, sort: 'int' }, // Amount column
                {
                    id: 'ResultType',
                    header: _('Resultado'), // Result Type column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocal',
                    header: _('Fecha Resultado'), // Created Date column with localization
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto Convertido'), // Converted Amount column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverRequired',
                    header: _('Rollover Requerido'), // Required Rollover column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverWagered',
                    header: _('Rollover Apostado'), // Wagered Rollover column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverRemaining',
                    header: _('Rollover Restante'), // Remaining Rollover column with localization
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'ClientBonusExpirationDateLocal',
                    header: _('Fecha Expiración'), // Expiration Date column with localization
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for detail icon click
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'es/Report/GetClientBonusReport?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // Data URL
        var filter = ''; // Filter string

        // Event listener for bonus report filtering
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
